import './pillars-incase.scss'

import Swiper, { Autoplay } from 'swiper'

function init() {
  const swiper = new Swiper('.pillars-incase__slider', {
    modules: [Autoplay],
    loop: true,
    autoHeight: true,

    autoplay: {
      delay: 1500,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      pauseOnMouseEnter: false,
    },
    slidesPerView: 2,
    spaceBetween: 24,
    direction: 'vertical',
    on: {
      init: (swiper) => {
        let totalGap = swiper.passedParams.spaceBetween * (swiper.passedParams.slidesPerView - 1)
        let containerHeight = swiper.passedParams.slidesPerView * swiper.slides[0].clientHeight + totalGap
        swiper.el.style.height = containerHeight + 'px'
      },
    },
  })
}
document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init()
  },
  { once: true }
)
